import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { DinamycLinkComponent } from './dinamyc-link/dinamyc-link.component';
import { ModalDownloadAppComponent } from "./modal-download-app/modal-download-app.component";
import { ModalNotificationComponent } from './modal-notification/modal-notification.component';
import { BuildingSidComponent } from './building-sid/building-sid.component';
import { CreateUserComponent } from './create-user/create-user.component';
import { CancelChangeComponent } from './cancel-change/cancel-change.component';
import { UiKitLayoutComponent } from './ui-kit/ui-kit-layout.component';
import { InfoChipPlaygroundComponent } from './ui-kit/info-chip-playground/info-chip-playground.component';
import { ButtonsPlaygroundComponent } from './ui-kit/buttons-playground/buttons-playground.component';
import { FoundationsPlaygroundComponent } from './ui-kit/foundations-playground/foundations-playground.component';
import { TogglePlaygroundComponent } from './ui-kit/toggle-playground/toggle-playground.component';
import { TextFieldPlaygroundComponent } from './ui-kit/text-field-playground/text-field-playground.component';
import { TimeFieldPlaygroundComponent } from './ui-kit/time-field-playground/time-field-playground.component';
import { SelectFieldPlaygroundComponent } from './ui-kit/select-field-playground/select-field-playground.component';
import { TabsPlaygroundComponent } from './ui-kit/tabs-playground/tabs-playground.component';
import { BadgePlaygroundComponent } from './ui-kit/badge-playground/badge-playground.component';
import { TooltipPlaygroundComponent } from './ui-kit/tooltip-playground/tooltip-playground.component';
import { CardPlaygroundComponent } from './ui-kit/card-playground/card-playground.component';
import { CheckboxPlaygroundComponent } from './ui-kit/checkbox-playground/checkbox-playground.component';
import { CheckboxListPlaygroundComponent } from './ui-kit/checkbox-list-playground/checkbox-list-playground.component';
import { IconAreaCardPlaygroundComponent } from './ui-kit/icon-area-card-playground/icon-area-card-playground.component';
import { AreaCardPlaygroundComponent } from './ui-kit/area-card-playground/area-card-playground.component';
import { IconButtonPlaygroundComponent } from './ui-kit/icon-button-playground/icon-button-playground.component';
import { PaginationButtonsPlaygroundComponent } from './ui-kit/pagination-buttons-playground/pagination-buttons-playground.component';
import { TextAreaFieldPlaygroundComponent } from './ui-kit/text-area-field-playground/text-area-field-playground.component';
import { FilterFieldsPlaygroundComponent } from './ui-kit/filter-fields-playground/filter-fields-playground.component';
import { AvatarPlaygroundComponent } from './ui-kit/avatar-playground/avatar-playground.component';
import { AreaPictureUploaderPlaygroundComponent } from './ui-kit/area-picture-uploader-playground/area-picture-uploader-playground.component';
import { TitlePreviewPlaygroundComponent } from './ui-kit/title-preview-playground/title-preview-playground.component';
import { InputPreviewPlaygroundComponent } from './ui-kit/input-preview-playground/input-preview-playground.component';
import { ReservationReviewCardPlaygroundComponent } from './ui-kit/reservation-review-card-playground/reservation-review-card-playground.component';
import { AreaPictureUploaderGalleryPlaygroundComponent } from './ui-kit/area-picture-uploader-gallery-playground/area-picture-uploader-gallery-playground.component';
import { ImagePreviewIconActionPlaygroundComponent } from './ui-kit/image-preview-icon-action-playground/image-preview-icon-action-playground.component';
import { PanelPlaygroundComponent } from './ui-kit/panel-playground/panel-playground.component';
import { TogglePanelPlaygroundComponent } from './ui-kit/toggle-panel-playground/toggle-panel-playground.component';
import { ScheduleCardPlaygroundComponent } from './ui-kit/schedule-card-playground/schedule-card-playground.component';
import { AlertPlaygroundComponent } from './ui-kit/alert-playground/alert-playground.component';
import { NotificationCardPlaygroundComponent } from './ui-kit/notification-card-playground/notification-card-playground.component';

const routes: Routes = [
  { path: 'dynamic-link', component: DinamycLinkComponent },
  { path: 'invitation_response', component: ModalDownloadAppComponent},
  { path: 'notifications', component: ModalNotificationComponent},
  { path: 'buildings', component: BuildingSidComponent },
  { path: 'create-user', component: CreateUserComponent },
  { path: 'cancel-change', component: CancelChangeComponent },
  {
    path: 'ui-kit',
    component: UiKitLayoutComponent,
    children: [
      { path: '', redirectTo: 'foundations', pathMatch: 'full' },
      { path: 'foundations', component: FoundationsPlaygroundComponent },
      { path: 'chip', redirectTo: 'info-chip', pathMatch: 'full' },
      { path: 'info-chip', component: InfoChipPlaygroundComponent },
      { path: 'buttons', component: ButtonsPlaygroundComponent },
      { path: 'toggle', component: TogglePlaygroundComponent },
      { path: 'text-field', component: TextFieldPlaygroundComponent },
      { path: 'time-field', component: TimeFieldPlaygroundComponent },
      { path: 'filter-fields', component: FilterFieldsPlaygroundComponent },
      { path: 'text-area-field', component: TextAreaFieldPlaygroundComponent },
      { path: 'select-field', component: SelectFieldPlaygroundComponent },
      { path: 'tabs', component: TabsPlaygroundComponent },
      { path: 'badge', component: BadgePlaygroundComponent },
      { path: 'tooltip', component: TooltipPlaygroundComponent },
      { path: 'card', component: CardPlaygroundComponent },
      { path: 'checkbox', component: CheckboxPlaygroundComponent },
      { path: 'checkbox-list', component: CheckboxListPlaygroundComponent },
      { path: 'icon-button', component: IconButtonPlaygroundComponent },
      { path: 'icon-area-card', component: IconAreaCardPlaygroundComponent },
      { path: 'area-card', component: AreaCardPlaygroundComponent },
      { path: 'pagination-buttons', component: PaginationButtonsPlaygroundComponent },
      { path: 'avatar', component: AvatarPlaygroundComponent },
      { path: 'area-picture-uploader', component: AreaPictureUploaderPlaygroundComponent },
      { path: 'title-preview', component: TitlePreviewPlaygroundComponent },
      { path: 'input-preview', component: InputPreviewPlaygroundComponent },
      { path: 'reservation-review-card', component: ReservationReviewCardPlaygroundComponent },
      { path: 'area-picture-uploader-gallery', component: AreaPictureUploaderGalleryPlaygroundComponent },
      { path: 'image-preview-icon-action', component: ImagePreviewIconActionPlaygroundComponent },
      { path: 'panel', component: PanelPlaygroundComponent },
      { path: 'toggle-panel', component: TogglePanelPlaygroundComponent },
      { path: 'schedule-card', component: ScheduleCardPlaygroundComponent },
      { path: 'alert', component: AlertPlaygroundComponent },
      { path: 'notification-card', component: NotificationCardPlaygroundComponent },
    ],
  },
  { path:"**", redirectTo: '/authentication/404', pathMatch: 'full'}
];

@NgModule({
  imports: [
    RouterModule.forChild(routes)
  ],
  exports: [RouterModule]
})
export class PublicRoutingModule { }
